<template>
  <v-app>
    <v-main>
      <v-card>
        <v-tabs v-model="tab" color="blue">
          <v-tab v-for="table in tables" :key="table.id" :value="table.id">{{
            "Таблица " + (Number(table.id) + 1)
          }}</v-tab>
          <v-btn style="align-self: center" icon="mdi-plus" @click="addTbl"
            >+</v-btn
          >
        </v-tabs>
        <v-card-text>
          <template v-for="table in tables">
            <TableTemp
              v-show="tab == table.id"
              :key="table.id"
              :url="url"
              :table="table"
              :dealID="dealID"
              :tables="tables"
              :typeEnum="typeEnum"
              :products="products"
            />
          </template>
        </v-card-text>
      </v-card>
    </v-main>
  </v-app>
</template>

<script>
import TableTemp from "./components/TableTemp.vue";
import BX24 from "bx24-api";
import axios from "axios";

export default {
  name: "App",

  components: {
    TableTemp,
  },

  data: () => ({
    tab: "0",
    text: "asdfasf",
    zoom: 62,
    tables: [],
    products: [],
    typeEnum: [],
    url: "https://rentasnab.bitrix24.ru/rest/8/z0v2bq3x0pxb96pb/",
    dealID: "3508",
  }),
  /* watch: {
    zoom(newZoom, lastZoom) {
      console.log(newZoom);
      console.log(lastZoom);
      this.$refs.app.style.setProperty("--zoom", `${newZoom}%`)
    },
  },*/
  methods: {
    plusZoom() {
      this.zoom += 5;
      console.log(this.zoom);
    },
    minusZoom() {
      this.zoom -= 5;
      console.log(this.zoom);
    },
    addTbl() {
      try {
        this.tables.push({ id: this.tables.length, value: "" });
      } catch (e) {
        console.log(e);
      }
    },
    async getTable() {
      try {
        this.tables = [];
        console.log("get products to deal");
        const dealData = await axios.post(this.url + "crm.deal.get", {
          id: this.dealID,
        });
        console.log({ dealData });
        for (const tableIndex in dealData.data.result.UF_CRM_1705579107440) {
          this.tables.push({
            id: tableIndex,
            value: dealData.data.result.UF_CRM_1705579107440[tableIndex],
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getProductTypeEnum() {
      try {
        const enumData = await axios.post(
          this.url + "catalog.productPropertyEnum.list",
          {
            filter: { propertyId: 374 },
          }
        );
        this.typeEnum.push(...enumData.data.result.productPropertyEnums);
        console.log(this.typeEnum, "typeEnum");
      } catch (e) {
        console.log(e);
      }
    },
    async getProducts() {
      try {
        this.products = [];
        const method = "catalog.product.list";
        const params = {
          select: ["*", "id", "iblockId"],
          filter: {
            iblockId: 16,
          },
          start: 0,
        };
        let isTrue = true;
        while (isTrue) {
          const productsData = await axios.post(this.url + method, params);
          console.log({ productsData });
          this.products.push(...productsData.data.result.products);
          console.log(productsData.data.next, "next");
          if (productsData.data.next) {
            params.start = productsData.data.next;
          } else {
            isTrue = false;
          }
        }
        console.log(this.products, "products");
      } catch (e) {
        console.log({ e });
      }
    },
  },
  async created() {
    const placementData = await BX24.placement.info();
    await BX24.fitWindow();
    this.dealID = placementData.options.ID;
    await this.getProducts();
    await this.getProductTypeEnum();
    await this.getTable();
  },
};
</script>
<style>
body {
  zoom: 90%;
}
</style>
